// @flow

const CookieService = {
  setCookie(name: string, value: string, days: number = 0) {
    let expires = '';

    if (days) {
      const date = new Date();

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${value}${expires};path=/`;
  },

  getCookie(name: string) {
    const coname = `${name}=`;
    const co = document.cookie.split(';');

    for (let i = 0; i < co.length; i += 1) {
      let c = co[i];

      c = c.replace(/^\s+/, '');

      if (c.indexOf(coname) === 0) {
        return c.substring(coname.length, c.length);
      }
    }

    return null;
  },
  deleteCookie(name: string) {
    CookieService.setCookie(name, '', -1);

    return null;
  },
};

export default CookieService;
